import React, { Component } from 'react';
import { connect } from 'react-redux';
import SortByFilterWeb from './SortByFilterWeb';
import PrizeFilterWeb from './PrizeFilterWeb';
import ClubsFilterWeb from './ClubsFilterWeb';
import common from '../../../common';
import PlayerSkillsFilterWeb from './playerSkillsFilterWeb';
import PlayerSortByWeb from './PlayerSortByWeb'
import PlayerRecomendationWeb from './PlayerRecomendationWeb'

class ExpandedFiltersWeb extends Component {
    render() {
        const expandedFilterClass = common.makeClasses({
            'si-filters-expanded': true,
            // 'si-display-none': !this.props.isFilterOpenForWeb
            'si-display-none': false
        });
        return <div className={expandedFilterClass}>
            <PlayerSkillsFilterWeb />
         
            <SortByFilterWeb />
            <ClubsFilterWeb />
            <div className="si-more-filters">
                <div className="si-dropdown-wrap si-dual">
                    <PrizeFilterWeb />
                    <PlayerSortByWeb />
                </div>

            </div>
            <PlayerRecomendationWeb />


        </div>
    }
}

const mapStateToProps = (state) => {
    return {
        isFilterOpenForWeb: state.formationData.isFilterOpenForWeb,
    };
};
export default connect(mapStateToProps, null)(ExpandedFiltersWeb);


// WEBPACK FOOTER //
// ./src/components/onboarding/filters/ExpandedFiltersWeb.js